// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"3f78f700","732":"46733d64"}[chunkId] + ".chunk.js";
};